import { Container } from "react-bootstrap";
import { RouteProps } from "react-router";
import Content from "Types/Content";

const Reuniones: React.FC<RouteProps> = () => {
  return (
    <Container className='pt-3'>
      <h1>
        <a href='https://docs.google.com/document/d/1HptnBZWk8ZS4mT50u9NiYahKZh85SrNGGk1owZGQQAM/edit'>
          Reuniones
        </a>
      </h1>
      <p className='text-justify'>
        En el ciclo de vida del desarrollo de software, dependiendo el estándar
        de trabajo definido exísten diferentes reuniones que ayudan a lograr un
        proceso sano. Las siguientes reuniones y conceptos deben ser tenidos en
        cuenta por el Proyect Manager para coordinar apropiadamente la
        comunicación entre los integrantes del equipo, y entre el equipo y el
        cliente.
      </p>
      <h2>Minutas</h2>
      <p className='text-justify'>
        De todas las reuniones se tiene que salir con una minuta, es
        importantísimo que cada desarrollador se lleve anotado todo, objetivos,
        fechas, hitos, etc. Puede no haber necesidad de la minuta, pero es una
        herramienta importante.
        <div className='alert alert-warning mt-2' role='alert'>
          La minuta solo si es necesario (no obligatorio)
        </div>
      </p>
      <h2>Daily</h2>
      <p className='text-justify'>
        Tanto Nacho como Brian, manifestaron la importancia de las dailys en lo
        que respecta a la comunicación entre los miembros del equipo y el líder
        del proyecto, en la cual cada uno de los integrantes comenta que hizo el
        dia anterior, si hubo algún tipo bloqueo en sus tareas y con qué tareas
        va a continuar durante el dia. Las dailys pueden tener una periodicidad
        diaria o también de día por medio.
        <div className='alert alert-warning mt-2' role='alert'>
          Tener en cuenta que las daily pueden no ser todos los días, día por
          medio también funciona
        </div>
      </p>
      <h2>Standup</h2>
      <p className='text-justify'>
        Nacho mencionó que viene realizando entre 2 a 3 por semana, una interna
        y una con el cliente. Los jueves tienen una charla previa a la charla
        con el cliente.
      </p>
      <h2>Comunicación a tope</h2>
      <p className='text-justify'>
        Es muy importante que el equipo tenga buena comunicación y pueda además
        de debatir posibles dudas mejores soluciones. Por ejemplo: Diseño de
        base de datos, diseño de interfaces, etc.
      </p>
    </Container>
  );
};

export default new Content({
  Component: Reuniones,
  title: "Reuniones",
  route: "reuniones",
  tags: [
    "buenas",
    "practicas",
    "reuniones",
    "coordinacion",
    "proyecto",
    "project",
    "manager",
    "management",
    "meetings",
    "fundamentos",
    "reglas",
    "calidad",
    "procesos",
    "process"
  ]
});
